'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        padding-left: ', ';\n        padding-right: ', ';\n      '], ['\n        padding-left: ', ';\n        padding-right: ', ';\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n            margin-left: auto;\n            margin-right: auto;\n          '], ['\n            margin-left: auto;\n            margin-right: auto;\n          ']),
    _templateObject3 = _taggedTemplateLiteral(['\n            margin-left: 0;\n            margin-right: 0;\n          '], ['\n            margin-left: 0;\n            margin-right: 0;\n          ']),
    _templateObject4 = _taggedTemplateLiteral(['\n          width:\n            ', ';\n          max-width:\n            ', ';\n        '], ['\n          width:\n            ', ';\n          max-width:\n            ', ';\n        ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  /**
   * Shows how much space takes the column on different screen sizes.
   * Total number of columns: 12.
   */
  size: _propTypes2.default.shape({
    xsmall: _propTypes2.default.number,
    small: _propTypes2.default.number,
    medium: _propTypes2.default.number,
    large: _propTypes2.default.number,
    xlarge: _propTypes2.default.number
  }),
  /** Set content flow direction */
  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  /** Set content align along horizontal axis */
  horizontalAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'space-between', 'space-around']),
  /** Set content align along vertical axis */
  verticalAlign: _propTypes2.default.oneOf(['stretch', 'center', 'start', 'end', 'baseline']),
  /** Removes column paddings */
  collapsed: _propTypes2.default.bool,
  /**
   * Shows on which screens block should be centered.
   * Centering starts from the smallest breakpoint, marked as true, up to
   * the next breakpoint marked as false.
   */
  centered: _propTypes2.default.shape({
    xsmall: _propTypes2.default.bool,
    small: _propTypes2.default.bool,
    medium: _propTypes2.default.bool,
    large: _propTypes2.default.bool,
    xlarge: _propTypes2.default.bool
  }),
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  size: { xsmall: 12 },
  layoutDirection: 'vertical',
  horizontalAlign: 'start',
  verticalAlign: 'start',
  collapsed: false,
  centered: null
};

/** PROP RECEIVERS */
var collapsed = function collapsed(_ref) {
  var collapsed = _ref.collapsed,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.grid.column,
      gutterHorizontal = _theme$reactackle$com.gutterHorizontal,
      breakpoints = _theme$reactackle$com.breakpoints;


  var baseGutter = 'calc(' + (0, _reactackleCore.getValueString)(gutterHorizontal) + ' / 2)';

  var paddingScale = breakpoints.map(function (item) {
    var gutter = 'calc(' + (0, _reactackleCore.getValueString)(item.gutterHorizontal) + ' / 2)';

    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, gutter, gutter));
  });

  return collapsed ? '\n      padding-left: 0;\n      padding-right: 0;\n    ' : (0, _styledComponents.css)(['padding-left:', ';padding-right:', ';', ''], baseGutter, baseGutter, paddingScale);
};

var centered = function centered(_ref2) {
  var centered = _ref2.centered,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var mediaQuery = theme.reactackle.breakpoints;

  var breakpoints = Object.keys(centered || {}).map(function (key) {
    var isBase = key === 'xsmall';

    if (isBase) {
      return centered[key] ? '\n            margin-left: auto;\n            margin-right: auto;\n          ' : '\n            margin-left: 0;\n            margin-right: 0;\n          ';
    } else {
      return centered[key] ? (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.media)(mediaQuery[key])(_templateObject2)) : (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.media)(mediaQuery[key])(_templateObject3));
    }
  });

  return centered ? breakpoints : null;
};

var calculateColumnWidth = function calculateColumnWidth(columnsAmount) {
  var totalColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reactackleCore.defaultTheme.totalColumns;
  return columnsAmount / totalColumns * 100 + '%';
};

var size = function size(_ref3) {
  var size = _ref3.size,
      themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var mediaQuery = theme.reactackle.breakpoints;

  var breakpoints = Object.keys(size || {}).map(function (key) {
    return key === 'xsmall' ? '\n        width:\n          ' + calculateColumnWidth(size[key], theme.reactackle.totalColumns) + ';\n        max-width:\n          ' + calculateColumnWidth(size[key], theme.reactackle.totalColumns) + ';\n      ' : (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(mediaQuery[key])(_templateObject4, calculateColumnWidth(size[key], theme.reactackle.totalColumns), calculateColumnWidth(size[key], theme.reactackle.totalColumns)));
  });

  return size ? breakpoints : null;
};

var mapMain = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  evenSpaceBetween: 'space-between',
  evenSpaceAround: 'space-around'
};

var mapCross = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  stretch: 'stretch',
  baseline: 'baseline'
};

var contentFlow = function contentFlow(_ref4) {
  var layoutDirection = _ref4.layoutDirection,
      mainAxisAlign = _ref4.mainAxisAlign,
      crossAxisAlign = _ref4.crossAxisAlign;

  var flowDirection = layoutDirection === 'horizontal' ? 'row' : 'column';

  return '\n    flex-direction: ' + flowDirection + ';\n    justify-content: ' + mapMain[mainAxisAlign] + ';\n    align-items: ' + mapCross[crossAxisAlign] + ';\n  ';
};

var base = function base(_ref5) {
  var themeFromProvider = _ref5.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
};

/** STYLES */
var ColumnStyled = exports.ColumnStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ColumnStyled'
})(['display:flex;flex-shrink:0;position:relative;width:100%;max-width:100%;', ' ', ' ', ' ', ' ', ';'], base, collapsed, centered, size, contentFlow);

ColumnStyled.propTypes = propTypes;
ColumnStyled.defaultProps = defaultProps;
ColumnStyled.displayName = 'ColumnStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-grid/dist/Column/styles/ColumnStyled.js
// module id = 684
// module chunks = 0